import styled from "styled-components";

export const Main = styled.main`
    max-width: 950px;
    padding: 30px;
    margin: 0 auto;

    @media (max-width: 767px) {
        padding: 10px;  
    }
`;